import cx from 'classnames';
import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import { useRobotSelector, useEditor } from '../context';
import { filterDocs } from '../docs';
import { monospace } from '../font';
import { EDITOR_TYPES } from '../robot.types';

// @ts-ignore
import styles from './robot__help.module.scss';

const RobotHelp = () => {
    const functionHints = useRobotSelector((s) => s.problem.markup.options.function_hints);
    const { editor } = useEditor();

    return useMemo(() => {
        const prepareText = (text: string) => {
            // если блокли, убираем скобки из строк вида `move_right()`, в блоках скобок нет
            if (editor === EDITOR_TYPES.BLOCKLY_PYTHON) {
                if (text.slice(-2) === '()') {
                    return text.slice(0, -2);
                }
            }
            return text;
        };

        return (
            <dl className={cx(styles.help, monospace, 'qa_robot-info-help')}>
                {Object.entries(filterDocs(functionHints)).map(([key, doc]) => (
                    <React.Fragment key={key}>
                        <dt className={styles.help_dt}>{prepareText(doc.text)}</dt>
                        <dd className={styles.help_dd}>
                            <FormattedMessage id={doc.help} />
                        </dd>
                    </React.Fragment>
                ))}
            </dl>
        );
    }, [functionHints, editor]);
};

export default RobotHelp;
